import React from 'react'
import User from 'EurestoClass/User'
import Datagrid from '../../Component/Datagrid/index'


import CardGrid from '../../Component/CardGrid'
import Grid from '@material-ui/core/Grid/Grid'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'

class Search extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      sort: props.sort || [],
      data: props.data || [],
      type: props.type,
      key: Utils.uuidv4(),
      loading: props.loading || false,
      scrollBodyPosition: 0,
      busGUID: Utils.uuidv4()
    }
  }

  resetPosition = () => {
    (User.User.get().list_view !== 0 || this.props.view === 'list') && $('#' + this.props.search + '-body').scrollTop(this.state.scrollBodyPosition)
  }

  componentWillUnmount() {
    Bus.$off('search_' + this.props.search, this.state.busGUID)
    Bus.$off('on_search_' + this.props.search, this.state.busGUID)
  }

  componentDidMount() {
    Bus.$on('search_' + this.props.search, d => {
      let indexSelected
      if (this.props.selected) {
        const p = d.data.findIndex(d => d[this.props.columnSelected || 'id'] === this.props.selected[this.props.columnSelected || 'id'])
        indexSelected = p !== -1 ? p : undefined
      }

      this.setState({
        indexSelected: indexSelected,
        data: d.data,
        sort: d.sort,
        over: d.over,
        loading: false,
        key: Utils.uuidv4()
      }, _ => {
        this.props.listenerData && this.props.listenerData(d.data)
        this.resetPosition()
      })
    }, this.state.busGUID)
    Bus.$on('on_search_' + this.props.search, _ => {
      this.setState({
        loading: true,
        over: false,
        scrollBodyPosition: $('#' + this.props.search + '-body').scrollTop(),
        key: Utils.uuidv4()
      }, this.resetPosition)
    }, this.state.busGUID)
  }

  render() {

    console.log(this.state.data)
    const { data, loading } = this.state
    console.log(data)
    console.log(loading)

    return (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'flex-start'} alignContent={'flex-start'}
        alignItems={'flex-start'} wrap={'nowrap'}>
        {(this.props.showSearch || sessionStorage.getItem('navigation') === 'false') && this.props.hideSearch !== true &&
          <Grid item style={{ margin: 0, padding: 0, marginTop: 25 }}>
            {this.props.searchComponent}
          </Grid>
        }
        <Grid item xs style={{ margin: 0, padding: 0 }}>
          {(User.User.get().list_view !== 0 || this.props.view === 'list') &&
            <Datagrid
              indexSelected={this.state.indexSelected}
              key={this.state.key}
              onClick={this.props.onClick}
              columnsName={this.props.columns}
              data={data}
              loading={loading}
              colorTD={this.props.colorTD}
              id={this.props.search}
              isSubComponent={true}
              defaultSorted={this.state.sort}
              trStyleCallback={this.props.trStyleCallback}
              style={{
                maxHeight: User.CalculHeight.getHeightWanted(),
                ...(this.props.style || {})
              }}
              search={this.props.search}
              infinityScroll={{
                over: this.state.over || false,
                isLoading: loading,
              }}
            /> ||
            <CardGrid card={this.props.card}
              onClick={this.props.onClick}
              loading={this.state.loading}
              over={this.state.over}
              type={this.props.type}
              data={this.state.data}
              search={this.props.search} />}
        </Grid>
      </Grid>)
  }
}

export default (Search)





// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Recherche/index.js